import React, { useState, useEffect, useRef } from "react";
import "./Workflow Transaction Creation.css";
import backButton from "../../../Assets/add-folder_ic.svg";
import CanvasHeader from "../../Common Components/Canvas_Header";
import WorkflowCanvas from "../../Common Components/Workflow_Canvas";
import { ReactFlowProvider } from "reactflow";

const CreateWorflowTemplate = ({ onBackClick, json, isSubflow, handleSubflowCanvasClick, isTransaction, workflow, Client, department }) => {
  const [client, setClient] = useState(Client);
  const [dept, setDept] = useState(department);
  const [emptyDropdown, setEmptyDropdown] = useState(false);
  const workflowCanvasRef = useRef(null);

  const handleOnSave = () => {
    console.log("save clicked");
  }

  const handleSelectChange = (event, type) => {
    switch (type
    ) {
      case "client":
        setClient(event.target.value);
        break;
      case "dept":
        setDept(event.target.value);
        break;
      default:
        console.log("no type matches");
    }
  };

  useEffect(() => {
    if (client === '--select--' || dept === '--select--') {
      setEmptyDropdown(true);
    } else {
      setEmptyDropdown(false);
    }
  }, [client, dept]);

  return (
    <>
      {/* <div className="backButton" onClick={onBackClick}>
        <img  src={backButton} alt="back button" />
        <p>Workflow Transaction List</p> */}
      <>
        <CanvasHeader backClick={onBackClick} saveJson={handleOnSave} backButtonLabel='Edit Workflow Transaction' handleSelectChanges={handleSelectChange} client={client} department={dept} isTransaction={isTransaction} isSubflow={isSubflow} event={false} />
        <WorkflowCanvas
          ref={workflowCanvasRef}
          isTransaction={isTransaction}
          workflow={workflow}
          emptyDropdown={emptyDropdown}
          json={json}
          isSubflow={isSubflow}
          handleSubflowCanvasClick={handleSubflowCanvasClick}
        />
      </>
      {/* </div> */}

    </>
  );
};

export default CreateWorflowTemplate;
